import { render, staticRenderFns } from "./basicConfigurationData.vue?vue&type=template&id=15918e9e&scoped=true"
import script from "./basicConfigurationData.vue?vue&type=script&lang=js"
export * from "./basicConfigurationData.vue?vue&type=script&lang=js"
import style0 from "./basicConfigurationData.vue?vue&type=style&index=0&id=15918e9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15918e9e",
  null
  
)

export default component.exports